import * as Yup from 'yup'

export const UserDetailsSchema = Yup.object().shape({
  role: Yup.string()
    .required('form.validation.required').nullable(),
  firstName: Yup.string()
    .required('form.validation.required'),
  lastName: Yup.string()
    .required('form.validation.required'),
  phoneNumber: Yup.string()
    .required('form.validation.required'),
  personalPhoneNumber: Yup.string().nullable(),
  email: Yup.string()
    .email('form.validation.email')
    .required('form.validation.required'),
  hash: Yup.string()
    .required('form.validation.required')
    .length(4, 'form.validation.userHash'),
  externalId: Yup.string().nullable(),
  mainGroupId: Yup.string().nullable(),
  extraGroupsIds: Yup.array()
    .of(Yup.string())
})

export const UserAccountSchema = Yup.object().shape({
  username: Yup.string()
    .min(6, 'form.validation.string.tooShort')
    .max(30, 'form.validation.string.tooLong')
    .required('form.validation.required'),
  password: Yup.string()
    .min(6, 'form.validation.string.tooShort')
    .max(30, 'form.validation.string.tooLong')
    .required('form.validation.required'),
  passwordConfirmation: Yup.string()
    .oneOf([Yup.ref('password'), null], 'form.validation.passwordMatch')
    .min(6, 'form.validation.string.tooShort')
    .max(30, 'form.validation.string.tooLong')
    .required('form.validation.required')
})
